import {scaleLinear} from 'd3-scale';
import {MetricInfoGroup} from '@store/@types/metric';

// svg dimensions dictate the entire canvas.
// this can scale up and down given the bounding parent size!
export const svgDimensions = {width: 400, height: 250} as const;
export const margins = {top: 0, left: 0, right: 0, bottom: 0} as const;
export const scales = {
  xScale: scaleLinear()
    .domain([0, 100])
    .range([margins.left, svgDimensions.width - margins.right]),
  yScale: scaleLinear()
    .domain([0, 100])
    .range([svgDimensions.height - margins.bottom, margins.top]),
};
export const COACHING_ZONE = {
  blockNames: [
    'ONE TO WATCH',
    'RISING STAR',
    'STAR PERFORMER',
    'DEVELOPMENT NEEDED',
    'CORE EMPLOYEE',
    'HIGH IMPACT',
    'LOW ENGAGEMENT',
    'SOLID CONTRIBUTOR',
    'SUBJECT MATTER EXPERT',
  ],
  title: ['COACHING', 'ZONE'],
};

export const groupLabels = {
  [MetricInfoGroup.SKILL]: 'Skill Metrics',
  [MetricInfoGroup.ENGAGEMENT]: 'Engagement Metrics',
  [MetricInfoGroup.KPI]: 'KPIs (used by these teams)',
  [MetricInfoGroup.SCORED_SKILLS]: 'Scored Skills',
};

export const groupColors = {
  [MetricInfoGroup.KPI]: '#C2EBE9',
  [MetricInfoGroup.SKILL]: '#D9F2D9',
  [MetricInfoGroup.ENGAGEMENT]: '#DBD9F2',
  [MetricInfoGroup.SCORED_SKILLS]: '#F2DAD9',
};

export enum CHART_DATA_FILTER {
  ALL = 'All Reps',
  MANAGER_COACHING = 'Reps {{MANAGER}} Coaching',
  MANAGER_NOT_COACHING = 'Reps w/o {{MANAGER}} Coaching',
}

export interface AxisRange {
  start: string;
  end: string;
}
